
import { Component, PropSync, Vue } from 'vue-property-decorator'
import TimeRange from "@/types/time/timeRange"

@Component({
  filters: {
  },
  components: {
  }
})
export default class DateRangeDialog extends Vue {
  @PropSync('dialog', { type: Boolean }) dateDialog!: boolean;
  private dates = []

  private get currentLanguageCode () {
    const languageCode = this.$store.getters["global/languageCode"]
    return languageCode + '-' + languageCode
  }

  private getTimeRangeFromDates () : TimeRange | undefined {
    if (!this.dates || this.dates.length < 1) return
    const lDates = this.dates
    if (this.dates.length === 1) lDates.push(this.dates[0])
    return new TimeRange({
      start: new Date(lDates[0]).setHours(0, 0, 0, 0),
      end: new Date(lDates[1]).setHours(23, 59, 59, 999)
    })
  }
}
